const MMNavigationRoutes = {
    ADMIN_SIGNUP: "/admin-signup",
    DASHBOARD: "/dashboard",
    ADMIN_LOGIN: "/admin-login",
    ADMIN_LOGIN_PAGE: "/admin-login-page",
    // Chapter Routes
    CHAPTER_PROFILE_LIST: "/chapter-profile-list",
    CHAPTER_PROFILE: "/chapter-profile",
    EDIT_CHAPTER: (id: string) => `/edit-chapter/${id}`,
    EDIT_CHAPTER_ROUTE: "/edit-chapter/:id",
    CREATE_CHAPTER_PROFILE: "/create-chapter-profile",
    EDIT_CHAPTER_PROFILE: (id: string) => `/edit-chapter-profile/${id}`,
    EDIT_CHAPTER_PROFILE_ROUTE: "/edit-chapter-profile/:id",

    // Relationships Routes

    CREATE_RELATIONSHIP: "/create-relationship",
    EDIT_RELATIONSHIP: (id: string) => `/edit-relationship/${id}`,
    EDIT_RELATIONSHIP_ROUTE: "/edit-relationship/:id",

    // Member Routes
    CREATE_MEMBER: "/create-member",
    EDIT_MEMBER: (id: string) => `/edit-member/${id}`,
    EDIT_MEMBER_ROUTE: "/edit-member/:id",
    MEMBER_LIST: "/member-list",

    // Events Routes
    EVENTS_LIST: "/events-list",
    CREATE_EVENT: "/create-event",
    EDIT_EVENT: (id: string) => `/edit-event/${id}`,
    EDIT_EVENT_ROUTE: "/edit-event/:id",

    // Sponsorship Routes
    SPONSORSHIP_LIST: "/sponsorship-list",
    CREATE_SPONSORSHIP: "/create-sponsorship",
    EDIT_SPONSORSHIP: (id: string) => `/edit-sponsorship/${id}`,
    EDIT_SPONSORSHIP_ROUTE: "/edit-sponsorship/:id",

    // Donation Routes
    DONATION_LIST: "/donation-list",
    CREATE_DONATION: "/create-donation",
    EDIT_DONATION: (id: string) => `/edit-donation/${id}`,
    EDIT_DONATION_ROUTE: "/edit-donation/:id",

    // Volunteering Routes
    VOLUNTEERING_LIST: "/volunteering-list",
    CREATE_VOLUNTEERING: "/create-volunteering",
    EDIT_VOLUNTEERING: (id: string) => `/edit-volunteering/${id}`,
    EDIT_VOLUNTEERING_ROUTE: "/edit-volunteering/:id",

    // Chapter Type Routes
    CHAPTER_TYPE: "/chapter-type",
    ADD_CHAPTER_TYPE: "/add-chapter-type",
    EDIT_CHAPTER_TYPE: (id: string) => `/edit-chapter-type/${id}`,
    EDIT_CHAPTER_TYPE_ROUTE: "/edit-chapter-type/:id",

    // Legal Status Routes
    LEGAL_STATUS: "/legal-status",
    ADD_LEGAL_STATUS: "/add-legal-status",
    EDIT_LEGAL_STATUS: (id: string) => `/edit-legal-status/${id}`,
    EDIT_LEGAL_STATUS_ROUTE: "/edit-legal-status/:id",

    // Settings Routes
    SETTINGS_LIST: "/settings-list",
    CREATE_SETTINGS: "/create-settings",
    EDIT_SETTINGS: (id: string) => `/edit-settings/${id}`,
    EDIT_SETTINGS_ROUTE: "/edit-settings/:id",

    // Invite Route
    INVITE: (chapterId: string) => `/${chapterId}`,
    INVITE_ROUTE: "/:chapterId",

    // Member Prefix Routes
    MEMBER_PREFIX: "/member-prefix",
    ADD_MEMBER_PREFIX: "/add-member-prefix",
    EDIT_MEMBER_PREFIX: (id: string) => `/edit-member-prefix/${id}`,
    EDIT_MEMBER_PREFIX_ROUTE: "/edit-member-prefix/:id",

    // Member Suffix Routes
    MEMBER_SUFFIX: "/member-suffix",
    ADD_MEMBER_SUFFIX: "/add-member-suffix",
    EDIT_MEMBER_SUFFIX: (id: string) => `/edit-member-suffix/${id}`,
    EDIT_MEMBER_SUFFIX_ROUTE: "/edit-member-suffix/:id",

    // Department Routes
    DEPARTMENT: "/department",
    ADD_DEPARTMENT: "/add-department",
    EDIT_DEPARTMENT: (id: string) => `/edit-department/${id}`,
    EDIT_DEPARTMENT_ROUTE: "/edit-department/:id",

    // Position Routes
    POSITION: "/position",
    ADD_POSITION: "/add-position",
    EDIT_POSITION: (id: string) => `/edit-position/${id}`,
    EDIT_POSITION_ROUTE: "/edit-position/:id",

    // Government ID Routes
    GOVERNMENT_ID: "/government-id",
    ADD_GOVERNMENT_ID: "/add-government-id",
    EDIT_GOVERNMENT_ID: (id: string) => `/edit-government-id/${id}`,
    EDIT_GOVERNMENT_ID_ROUTE: "/edit-government-id/:id",

    // Zulip Chat
    CHAT_PAGE: `/chat`,

    // SOP Routes
    SOP_LIBRARY: "/sops",
    CREATE_SOP: "/create-sop",
    EDIT_SOP: (id: string) => `/edit-sop/${id}`,
    EDIT_SOP_ROUTE: "/edit-sop/:id",

    // Civi_Circle_User Routes
    NEW_DESIGN: "/new-design",

    // Department Routes
    DEPARTMENT_LIST: "/department-list",
    CITY_COLLABORATIONS: "/city-collaborations",

    // Feed Creation Route
    FEED_CREATION: "/feed-creation",

    // Error Logs Route
    ERROR_LOGS: "/error-logs",
};

export default MMNavigationRoutes;
